var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\r\n<table class=\"backgrid table table-striped\">\r\n  <thead></thead>\r\n  <tbody></tbody>\r\n</table>\r\n<div class=\"paginator-container\"></div>";
},"useData":true});